import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@brighterion/br-ui';
import { trackEvent, EventTypes, EventNames } from '@brighterion/insights';
import { handleOnClickEvent } from 'Utils';

const NewRuleTestButton = () => {
    const { t } = useTranslation();
    const handleOnClick = () => {
        // TODO: integrate with start new rule test API in future stories
        trackEvent({
            eventType: EventTypes.track,
            eventName: EventNames.click,
            payload: {
                clickIdentifier: 'Manage Rule Tests - New Rule Test',
                text: 'New Rule Test'
            }
        });
    };
    return (
        <Button
            dataTestId='newRuleTestButton'
            variant='primary'
            size='small'
            onClick={handleOnClickEvent(handleOnClick)}
        >
            {t('New Rule Test')}
        </Button>
    );
};

export default NewRuleTestButton;
